import React from 'react';
import { Box, Heading } from '@zillow/constellation';
import { useLastValidRefinanceValues } from './RefinanceCalculator.utils.js';
import { getWholeDollars } from '../../utils/zhl-calculator.js';

var SavingsHeader = function SavingsHeader() {
  var values = useLastValidRefinanceValues();
  var headerText = values.calculations.monthlySavings > 0 || values.calculations.lifetimeSavings > 0 ? 'Refinancing could save you' : 'Sorry, refinancing will not save you money';
  var savingsText = null;
  var _ref = values.calculations || {},
    monthlySavings = _ref.monthlySavings,
    lifetimeSavings = _ref.lifetimeSavings;
  if (monthlySavings > 0) {
    savingsText = getWholeDollars(monthlySavings) + " /mo";
  } else if (lifetimeSavings > 0) {
    savingsText = getWholeDollars(lifetimeSavings);
  }
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "5"
  }, headerText), /*#__PURE__*/React.createElement(Heading, {
    level: "3"
  }, savingsText));
};
var SavingsHeader$1 = SavingsHeader;

export { SavingsHeader$1 as default };
